module.exports = __webpack_public_path__ + "static/media/greengully-logo.883ae5e2.png";